<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      v-can="'customrepresentativeprice.update'"
      class="item"
      effect="dark"
      content="Másolás"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-document-copy"
        @click.stop="copyPartnerPrice"
      />
    </el-tooltip>
    <el-tooltip
      v-can="'customrepresentativeprice.view'"
      class="item"
      effect="dark"
      content="Letöltés"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-download"
        @click.stop="download"
      />
    </el-tooltip>
    <el-tooltip
      v-can="'customrepresentativeprice.update'"
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        style="margin-left: 5px;"
        @click.stop="updatePartnerPrice"
      />
    </el-tooltip>
    <el-tooltip
      v-can="'customrepresentativeprice.delete'"
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click.stop="deletePartnerPrices"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          style="margin-left: 5px;"
          icon="el-icon-delete"
          @click.stop=""
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  import { saveAs } from 'file-saver';

  export default {
    props: ['price'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },

    methods: {
      async updatePartnerPrice() {
        this.$router.push('/representative-processes/representative-prices/custom/update/' + this.price.id);
      },
      async copyPartnerPrice() {
        this.$router.push('/representative-processes/representative-prices/custom/add/' + this.price.id);
      },
      async deletePartnerPrices() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('customRepresentativePriceList/delete', this.price.id);
          this.$store.dispatch('customRepresentativePriceList/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },

      async download(e) {
        try {
          const excel = await axios({
            url: `api/representative-price-lists/${this.price.id}/export`,
            method: 'POST',
            responseType: 'blob',
          });
          console.log(excel)
          saveAs(excel, `customprices.xlsx`);
        } catch (e) {}
      },
    }
  };
</script>
